var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.111,
    height: 68.111,
    viewBox: "0 0 68.111 68.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M68.111,0H0V68.111H68.111Z",
    fill: "#5763f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-svgrepo-com",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M39.893,8.676H17.772c-3.164,0-4.311.329-5.466.948a6.463,6.463,0,0,0-2.682,2.682c-.619,1.155-.948,2.3-.948,5.466V39.893a2.838,2.838,0,0,1-5.676,0V17.553c0-5.06.528-6.9,1.515-8.747A10.316,10.316,0,0,1,8.806,4.515C10.657,3.528,12.493,3,17.553,3h22.34a2.838,2.838,0,0,1,0,5.676ZM17.982,15.3c1.155-.619,2.3-.948,5.466-.948h21.54c3.164,0,4.311.329,5.466.948a6.448,6.448,0,0,1,2.682,2.682c.619,1.155.948,2.3.948,5.466v21.54c0,3.161-.329,4.311-.948,5.466a6.463,6.463,0,0,1-2.682,2.682c-1.155.619-2.3.948-5.466.948H23.447c-3.161,0-4.311-.329-5.466-.948A6.463,6.463,0,0,1,15.3,50.453c-.619-1.155-.948-2.3-.948-5.466V23.447c0-3.164.329-4.311.948-5.466A6.448,6.448,0,0,1,17.982,15.3Z",
    transform: "translate(5.514 5.514)",
    fill: "#5763f3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight4);
export default __webpack_public_path__ + "static/media/right_4.70e8022ad0fd2639202450f8fa7c7a41.svg";
export { ForwardRef as ReactComponent };